// FieldsManagerComponent.js

import React, { useEffect, useState } from 'react';
import { Box, DataTable, Text, ResponsiveContext, Heading, Card, CardBody, CardHeader, Image, ScrollView } from 'grommet';
import { useDataContext } from '../Contexts/DataContext';
import { calculateHeight } from "../Utils/Utils";
import HomePageNav from "../Base components/HomePageNav";

const FieldTable = ({ fieldList }) => {
    return (
        <ResponsiveContext.Consumer>
        {screenSize => (
            <Box
            width="90vw" // Full screen width
            height="100vh" // Full screen height
            background="light-1" // Apply background color to the entire screen
            align="center"
            justify="center"
        >       
        <Box align="center" justify="center">
            <Card
                background="light-1"
                width='100%'
                elevation="xxsmall"
                pad="medium"
            >
                <CardHeader pad="medium" align="center" justify="center">
                    <Heading level="2" margin={{ bottom: 'medium' }}>Field Information</Heading>
                </CardHeader>
                <CardBody pad="medium">
                    {/* Add scrollable container with fixed width */}
                    <Box width="880px" height="400px" overflow={{ vertical: 'auto' }}>
                        <DataTable
                            columns={[
                                { property: 'FieldName', header: <Text>Name</Text>, primary: true },
                                { property: 'FieldType', header: <Text>Type</Text>, render: (datum) => (datum.FieldType === 1 ? 'Sukkot' : 'Stations') }, 
                                { property: 'RowFrom', header: <Text>From Row</Text>, align: 'end' },
                                { property: 'RowTo', header: <Text>To Row</Text>, align: 'end' },
                                { property: 'VinesOnRow', header: <Text>Vines On Row</Text>, align: 'end' },
                                { property: 'Description', header: <Text>Description</Text> },
                            ]}
                            data={fieldList}
                            pad="small"
                        />
                    </Box>
                </CardBody>
            </Card>
        </Box>
        </Box> 
        )}
        </ResponsiveContext.Consumer>
    );
};


// Parent component
const FieldsManagerComponent = () => {
    const { fieldList } = useDataContext();
    // const size = useContext(ResponsiveContext); // Get screen size

    return (
        <ResponsiveContext.Consumer>
        {screenSize => (
        <Box 
            width="100%" // Set the Box width to 100%
            background={{color: "#ffffff"}}
            alignSelf="center"
        >
            <Box  flex fill="vertical"
                style={{ 
                    position: 'fixed',
                    top: 0,
                    zIndex: 10,
                    height: calculateHeight(5)
                }}
                >

                <Box justify="center">  {/*Center content vertically  */}
                    <HomePageNav/>
                </Box>              
            </Box>
            <Box>
                <Box width="98%" margin="0 auto" style={{ height:"40px", minHeight:"40px"}}>
                    <Box style={{position:"relative"}}>
                        <Box background="neutral-3" pad={{vertical: "small"}} margin={{vertical: "xxsmall"}} >
                            <Box direction="row" justify="center" align="center">
                                <Text size="large" weight="bold" color="#ffffff" > Vineyards Management </Text>
                            </Box>              
                        </Box>  
                        <Box
                            width={{ 
                                "xsmall": "60px",
                                "small": "90px",
                                "medium": "90px",
                                "large": "120px",
                                "xlarge": "120px"
                                }[screenSize] || "120px"} // Default to "120px" if screenSize is not matched 
                            height={{ 
                                "xsmall": "60px",
                                "small": "90px",
                                "medium": "90px",
                                "large": "120px",
                                "xlarge": "120px"
                                }[screenSize] || "120px"} // Default to "120px" if screenSize is not matched
                            style={{ position: "absolute", right: "3%", top: "10px" }}
                            >
                                <Image
                                    fit="contain"
                                    src="Grape.png"                               
                                />
                        </Box>                        
                    </Box>      
                </Box>

                <Box align="center" justify="center" width="100%">  
                    <FieldTable fieldList={fieldList} />
                </Box>
            </Box>
        </Box>  
        )}
        </ResponsiveContext.Consumer>

    );
};

export default FieldsManagerComponent;


